/**
 * Skeleton loader for the board/kanban view.
 */

function SkeletonCard({ index }: { index: number }) {
  const heights = ['h-20', 'h-24', 'h-16', 'h-28', 'h-20'];
  return (
    <div className={`${heights[index % heights.length]} rounded-lg bg-surface-hover animate-pulse`} />
  );
}

function SkeletonColumn({ cards, index }: { cards: number; index: number }) {
  return (
    <div className="w-[280px] shrink-0 flex flex-col gap-2">
      <div className="flex items-center gap-2 px-2 py-2">
        <div className="w-3 h-3 rounded-full bg-surface-hover animate-pulse" />
        <div className="w-20 h-3 rounded bg-surface-hover animate-pulse" />
        <div className="w-5 h-4 rounded bg-surface-hover animate-pulse ml-1" />
      </div>
      <div className="flex flex-col gap-2 px-1">
        {Array.from({ length: cards }).map((_, i) => (
          <SkeletonCard key={i} index={i + index} />
        ))}
      </div>
    </div>
  );
}

export function BoardSkeleton({ columns = 5 }: { columns?: number }) {
  const cardCounts = [4, 3, 2, 5, 1];
  return (
    <div className="flex gap-4 p-4 overflow-x-auto animate-fade-in">
      {Array.from({ length: columns }).map((_, i) => (
        <SkeletonColumn key={i} cards={cardCounts[i % cardCounts.length]} index={i} />
      ))}
    </div>
  );
}
